<template>
    <div>
        <el-card>
            <div class="tableBox">
                <div>
                    <div>
                        <span>服务台</span>
                        <span>事件关闭统计</span>
                    </div>
                    <img src="../../../../assets/icon_logo.png">
                </div>
                <div>
                    <div>
                        <el-form :inline="true" class="search-form">
                            <el-form-item label="">
                                <el-date-picker
                                    ref="dataPicker"
                                    @change="changeData"
                                    v-model="value"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-button type="primary" @click="selectData">修改时间</el-button>
                        </el-form>
                    </div>
                    <div class="tableClass">
                        <div>
                            <el-table
                                :data="tableData"
                                show-summary>
                                <el-table-column width="80" prop="name" label="人员名称"></el-table-column>
                                <el-table-column prop="num1" label="及时关闭事件数" sortable :sort-orders="sortList"></el-table-column>
                                <el-table-column prop="num2" label="有满意度调查事件数" sortable :sort-orders="sortList"></el-table-column>
                                <el-table-column prop="num3" label="事件总数" sortable :sort-orders="sortList"></el-table-column>
                                <el-table-column prop="rate1" label="及时关闭事件数占比" sortable :sort-orders="sortList"></el-table-column>
                                <el-table-column prop="rate2" label="满意度调查占比" sortable :sort-orders="sortList"></el-table-column>
                            </el-table>
                        </div>
                        <div ref="myChart"></div>
                    </div>
                </div>
                <div>
                    <div>
                        <span>生成时间:</span>
                        <span>2019-09-06 10:43:37</span>
                    </div>
                    <span>itsmops.autoai.com</span>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>

    export default {
        data: function () {
            return {
                tableData: [
                    {name: '王雪昕',num1: '1',num2:'9',num3: '200',rate1: '0.42',rate2: '0.42'},
                    {name: '刘敏',num1: '6',num2:'5',num3: '300',rate1: '0.32',rate2: '0.52'}
                ],
                sortList:['descending', 'ascending'],
                value:'',
                options:{
                    tooltip : {},
                    legend: {},
                    dataset:{
                        source:[
                            ['product','及时关闭事件数','有满意度调查事件数','事件总数','及时关闭事件数占比','满意度调查占比'],
                            ['王雪昕','6','60','300','24','32'],
                            ['刘敏','6','60','300','24','32'],
                            ['刘敏1','6','60','300','24','32'],
                            ['刘敏3','6','60','300','24','32'],
                            ['刘敏2','6','60','300','24','32'],
                        ]
                    },
                    dataZoom:[
                        {
                            type: 'inside',
                            xAxisIndex: 0,
                        },
                        {
                            type: 'slider',
                            xAxisIndex: 0,
                        },
                        {
                            type: 'inside',
                            yAxisIndex: 0,
                        },
                        {
                            type: 'slider',
                            yAxisIndex: 0,
                        },
                    ],
                    xAxis: [{type: 'category',}],
                    yAxis: [{}],
                    series: [
                        {
                            type:'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                        {
                            type:'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                        {
                            type:'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                        {
                            type:'bar',
                            label: {
                                normal: {
                                    formatter: '{@[4]}%',
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                        {
                            type:'bar',
                            label: {
                                normal: {
                                    formatter: '{@[5]}%',
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                    ]
                },
            }
        },
        mounted(){
            this.getEcharts();
        },
        methods:{
            selectData(){//点击修改日期 日期控件自动聚焦
                let selData = this.$refs.dataPicker;
                selData.focus();
            },
            changeData(){//选择日期
                alert(12)
            },
            getEcharts(item){//实例化图标
                let myChart = this.$echarts.init(this.$refs.myChart);
                myChart.setOption(this.options);
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .tableClass{
        display: flex;
        &>div:nth-child(1){
            width: 55%;
        }
        &>div:nth-child(2){
            width: 45%;
            height:400px;
        }
    }
</style>
